import React, { Fragment } from 'react'
import Lightbox from 'react-images'

const WithSimpleLightbox = (ImagesContainer) => class SimpleLightbox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lightboxIsOpen: false,
      currentImage: 0,
    }

    this.images = this.props.attachments.filter(
      attachment => attachment.attributes.contentType === 'image'
    ).map(image => ({ src: image.attributes.url }))

    this.openLightbox = this.openLightbox.bind(this)
    this.closeLightbox = this.closeLightbox.bind(this)
    this.gotoNext = this.gotoNext.bind(this)
    this.gotoPrevious = this.gotoPrevious.bind(this)
    this.handleClickImage = this.handleClickImage.bind(this)
  }

  openLightbox(index) {
    this.setState({
      currentImage: index,
      lightboxIsOpen: true,
    })
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false,
    })
  }

  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1,
    })
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1,
    })
  }

  handleClickImage(event) {
    event.stopPropagation()

    if (this.state.currentImage + 1 === this.images.length) return;

    this.gotoNext()
  }

  render() {
    return (
      <Fragment>
        <ImagesContainer
          {...this.props}
          onImageClick={this.openLightbox}
        />
        <Lightbox
          currentImage={this.state.currentImage}
          images={this.images}
          isOpen={this.state.lightboxIsOpen}
          onClickImage={this.handleClickImage}
          onClickNext={this.gotoNext}
          onClickPrev={this.gotoPrevious}
          onClose={this.closeLightbox}
          backdropClosesModal
        />
      </Fragment>
    )
  }
}

export default WithSimpleLightbox
